<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="tile" [class.pb-0]="!collapsed()">
  <div class="d-flex justify-content-between">
    <div class="zero-text p-bigger-med mb-2">
      {{ 'asset-class-overview.shared.most-active-assets.headline' + (instrumentType() ? '-' + instrumentType() : '') | transloco }}
    </div>
    <web-design-system-icon-button (click)="collapse()" type="grey-light" size="small" [icon]="collapsed() ? 'chevron' : 'chevron-2'" />
  </div>
  @if (!collapsed()) {
    @if (facade.mostActiveAssets$ | async; as mostActiveAssets) {
      <div class="d-block d-xl-flex justify-content-between mt-3 ignore-margin">
        <div class="w-100 px-3 mb-3 mb-xl-0 border-right">
          <div class="d-flex align-items-center justify-content-start gap-half py-2 zero-text p-big-med">
            <web-design-system-icon name="most-active-buy" />
            {{ 'asset-class-overview.shared.most-active-assets.header.buy' | transloco }}
            <web-design-system-icon
              name="info"
              size="small"
              [ngbTooltip]="'asset-class-overview.shared.most-active-assets.tooltip.buy' | transloco"
              tooltipClass="zero-tooltip"
              placement="bottom"
            />
          </div>
          @if (mostActiveAssets.instrumentsByBuyRank?.length) {
            @for (etf of mostActiveAssets.instrumentsByBuyRank; track etf.isin) {
              <ng-container *ngTemplateOutlet="item; context: { etf, type: 'instrumentsByBuyRank' }" />
            }
          } @else {
            <div class="zero-text p-small-med pb-3">{{ 'asset-class-overview.shared.most-active-assets.no-data' | transloco }}</div>
          }
        </div>
        <div class="w-100 px-3 mb-3 mb-xl-0 border-right">
          <div class="d-flex align-items-center justify-content-start gap-half py-2 zero-text p-big-med">
            <web-design-system-icon name="most-active-sell" />
            {{ 'asset-class-overview.shared.most-active-assets.header.sell' | transloco }}
            <web-design-system-icon
              name="info"
              size="small"
              [ngbTooltip]="'asset-class-overview.shared.most-active-assets.tooltip.sell' | transloco"
              tooltipClass="zero-tooltip"
              placement="bottom"
            />
          </div>
          @if (mostActiveAssets.instrumentsBySellRank?.length) {
            @for (etf of mostActiveAssets.instrumentsBySellRank; track etf.isin) {
              <ng-container *ngTemplateOutlet="item; context: { etf, type: 'instrumentsBySellRank' }" />
            }
          } @else {
            <div class="zero-text p-small-med pb-3">{{ 'asset-class-overview.shared.most-active-assets.no-data' | transloco }}</div>
          }
        </div>
        <div class="w-100 px-3">
          <div class="d-flex align-items-center justify-content-start gap-half py-2 zero-text p-big-med">
            <web-design-system-icon name="ranking" />
            {{ 'asset-class-overview.shared.most-active-assets.header.rank' | transloco }}
            <web-design-system-icon
              name="info"
              size="small"
              [ngbTooltip]="'asset-class-overview.shared.most-active-assets.tooltip.rank' | transloco"
              tooltipClass="zero-tooltip"
              placement="bottom"
            />
          </div>
          @if (mostActiveAssets.instrumentsByRank?.length) {
            @for (etf of mostActiveAssets.instrumentsByRank; track etf.isin) {
              <ng-container *ngTemplateOutlet="item; context: { etf, type: 'instrumentsByRank' }" />
            }
          } @else {
            <div class="zero-text p-small-med pb-3">{{ 'asset-class-overview.shared.most-active-assets.no-data' | transloco }}</div>
          }
        </div>
      </div>
    } @else {
      <div class="zero-text p-small-med">{{ 'asset-class-overview.shared.most-active-assets.no-data' | transloco }}</div>
    }
  }
</div>

<ng-template #item let-etf="etf" let-type="type">
  <div class="border-top ignore-margin"></div>
  <div class="d-sm-flex justify-content-between align-items-center py-2 gap-small">
    <div class="truncate" [title]="etf.name">
      <web-components-instrument-details-link linkCssClass="zero-text p-base-med default" [isin]="etf.isin">{{
        etf.name
      }}</web-components-instrument-details-link>
    </div>

    <div class="d-flex align-items-center gap-small mt-2 mt-sm-0 justify-content-end justify-content-sm-start">
      <div class="quote d-flex justify-content-end zero-text p-base-med" zeroBlink [val]="etf?.quote?.ask">
        {{ etf?.quote?.ask | currency: 'EUR' : 'symbol' : '1.2' }}
      </div>
      @if (etf?.performance >= 0 || etf?.performance < 0) {
        <div
          class="perf d-flex justify-content-end zero-text p-base-med text-nowrap"
          [ngClass]="etf.performance >= 0 ? { 'course-green': true } : { 'course-red': true }"
        >
          {{ etf.performance >= 0 ? '+' : '' }}{{ etf.performance | number: '1.2-2' }} %
        </div>
      } @else {
        <div class="perf d-flex justify-content-center">&mdash;</div>
      }
    </div>
  </div>
</ng-template>
